import { createBrowserHistory, History } from 'history';

// Create browser history once to be shared across the application
export const browserHistory: History = createBrowserHistory();
